export const CityService = {
  Video: 'video',
  Paper: 'paper',
};
